import React from "react";
import { Playlist } from "./playlist/Playlist";
import { IPlaylistResponseDto } from "../../types";
import { playlistsService } from "../../services";

export const PlaylistsCollection: React.FC<{
    clientId: string;
    enableRatingControls: boolean;
    sessionToken: string;
    isSignedIn: boolean;
    mediaPerPage: number;
    enableAutoplay: boolean;
    isolatePlaylistId?: string;
}> = ({
    clientId,
    enableRatingControls,
    sessionToken,
    isSignedIn,
    mediaPerPage,
    enableAutoplay,
    isolatePlaylistId
}) => {
        const [playlists, setPlaylists] = React.useState<IPlaylistResponseDto[]>(
            []
        );

        const fetchPlaylists = React.useCallback(async () => {
            try {
                const response = await playlistsService.getAllPlaylists(
                    clientId,
                    mediaPerPage
                );
                console.log(response);
                if (isolatePlaylistId) {
                    const filtered = response.filter(
                        (playlist) => playlist.playlistId === isolatePlaylistId
                    );
                    setPlaylists(filtered);
                } else {
                    setPlaylists(response);
                }
            } catch (err) {
                console.log("There is an error while fetching playlists", err);
            }
        }, [clientId, setPlaylists, mediaPerPage, isolatePlaylistId]);

        React.useEffect(() => {
            fetchPlaylists();
        }, [fetchPlaylists]);

        return (
            <>
                {playlists?.map((playlist) => (
                    <Playlist
                        key={playlist.playlistId}
                        playlist={playlist}
                        clientId={clientId}
                        enableRatingControls={enableRatingControls}
                        sessionToken={sessionToken}
                        isSignedIn={isSignedIn}
                        mediaPerPage={mediaPerPage}
                        enableAutoplay={enableAutoplay}
                    />
                ))}
            </>
        );
    };
